import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/App.css";
import Content from "./components/layout/Content";
import Topbar from "./components/layout/Topbar";
import Sidebar from "./components/layout/Sidebar";
import { MicrosoftAuthProvider } from "./context/MicrosoftAuthContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from "react-router-dom";
import { LayoutProvider, useLayout } from "./context/LayoutContext";
import { ThemeProvider } from "./context/ThemeContext";
import ScrollToTop from "./components/common/ScrollToTop";

// Define a global error handler for MSAL errors
window.addEventListener('error', function (event) {
  if (event.error && event.error.message && event.error.message.includes('MSAL')) {
    console.error('MSAL Error caught by global handler:', event.error);
  }
});

const AppShell = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const isDocsPage = location.pathname.includes("/docs/");
  const { isSidebarCollapsed, expandedWidth, collapsedWidth, isMobile } = useLayout();

  const sidebarWidth = isMobile ? 0 : (isSidebarCollapsed ? collapsedWidth : expandedWidth);

  return (
    <>
      <ScrollToTop />
      {!isLoginPage && !isDocsPage && <Sidebar />}
      {!isLoginPage && !isDocsPage && <Topbar />}
      <div
        className="App wrapper bg-white dark:bg-[#000000] position-relative transition-colors duration-200"
        style={!isLoginPage && !isDocsPage ? {
          marginLeft: `${sidebarWidth}px`,
          paddingTop: '60px',
          width: `calc(100% - ${sidebarWidth}px)`,
          maxWidth: `calc(100vw - ${sidebarWidth}px)`
        } : {}}
      >
        {/* Content */}
        <Content />
      </div>
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        theme={localStorage.getItem('theme') === 'dark' ? 'dark' : 'light'}
        toastStyle={{
          backgroundColor: localStorage.getItem('theme') === 'dark' ? '#1a1a1a' : '#ffffff',
          color: localStorage.getItem('theme') === 'dark' ? '#ffffff' : '#333333',
          border: '1px solid',
          borderColor: localStorage.getItem('theme') === 'dark' ? '#333333' : '#e5e7eb'
        }}
        progressStyle={{
          background: localStorage.getItem('theme') === 'dark' ? '#CD6D2C' : '#CD6D2C'
        }}
      />
    </>
  );
};

const App = () => {
  return (
    <MicrosoftAuthProvider>
      <ThemeProvider>
        <LayoutProvider>
          <AppShell />
        </LayoutProvider>
      </ThemeProvider>
    </MicrosoftAuthProvider>
  );
};

export default App;
